import React, { useState } from 'react'
import { Link, Route } from 'react-router-dom'
import { Layout, Menu, Breadcrumb, Icon } from 'antd'

import {
  GettingStarted,
  Colors,
  Buttons,
  Typography,

  Accordions,
  Carousel,
  ListItemLabel,
  Modal,
  MultiSelectbox,
  Notification,
  Navigations,
  Tabs,
  Tables,
  Tooltip,
  Calendar,

  Spacings,
  Floats,
  Positions,
  Displays,
  List,
  Texts,
  VerticalAlignment,

  Inputs,
  Search,
  CheckBoxs,
  SelectBox,
  FormControl,
  AutoComplete
} from '../pages'

const { SubMenu } = Menu
const { Header, Content, Footer, Sider } = Layout

const menuMap = {
  'Base': {
    'Colors': Colors,
    'Buttons': Buttons,
    'Typography': Typography,
  },
  'Displays': {
    'Accordions': Accordions,
    'Carousel': Carousel,
    'ListItemLabel': ListItemLabel,
    'Modal': Modal,
    'MultiSelectbox': MultiSelectbox,
    'Navigations': Navigations,
    'Notification': Notification,
    'Tables': Tables,
    'Tabs': Tabs,
    'Tooltip': Tooltip,
    'Calendar': Calendar,
  },
  'Helper': {
    'Displays': Displays,
    'Floats': Floats,
    'List': List,
    'Positions': Positions,
    'Spacings': Spacings,
    'Texts': Texts,
    'VerticalAlignment': VerticalAlignment,
  },
  'Forms': {
    'CheckBoxs': CheckBoxs,
    'Inputs': Inputs,
    'Search': Search,
    'SelectBox': SelectBox,
    'FormControl': FormControl,
  },
  'Function': {
    'AutoComplete': AutoComplete,
  },
}

const menuItem = Object.keys(menuMap).map((key) => {

  const submenuItem = Object.keys(menuMap[key]).map((subkey) => {
    return (
      <Menu.Item key={subkey}><Link to={'/' + key + '/' + subkey}>{subkey}</Link></Menu.Item>
    )
  })

  return (
    <SubMenu key={key} title={key}>
      {submenuItem}
    </SubMenu>
  )
})

let routeItem = []
Object.keys(menuMap).map((key) => {

  const routeSubItem = Object.keys(menuMap[key]).map((subkey) => {
    return (
      <Route key={subkey} path={'/' + key + '/' + subkey} component={menuMap[key][subkey]}></Route>
    )
  })

  return routeItem = routeItem.concat(routeSubItem)
})

const LayoutComponent = () => {
  const [openKeys, setOpenKeys] = useState(['Base', 'Displays', 'Forms', 'Helper'])
  const onOpenChange = changeKeys => setOpenKeys(changeKeys)

  // const pathSnippets = window.location.pathname.split('').filter(i => i)
  // const extraBreadcrumbItems = pathSnippets.map((_, index) => {
  //   const url = `/${pathSnippets.slice(0, index + 1).join('')}`
  //   return (
  //     <Breadcrumb.Item key={url}>
  //       <Link to={url}>{menuMap[url]}</Link>
  //     </Breadcrumb.Item>
  //   )
  // })

  return (
    <>
      <Layout>
        <Sider breakpoint="lg" collapsedWidth="0" style={{ background: '#fff', minHeight: '100vh' }}>
          <Menu mode="inline" defaultSelectedKeys={['1']} openKeys={openKeys} onOpenChange={onOpenChange}>
            <Menu.Item key="1">
              <Icon type="home"/>
              <span>
                <Link to="/GettingStarted">Getting Started</Link>
              </span>
            </Menu.Item>
            {menuItem}
          </Menu>
        </Sider>
        <Layout>
          <Header style={{ background: '#fff', padding: 0 }}>
            <div className="Logo">Mania FrameWork</div>
          </Header>
          <Content style={{ margin: '24px 16px 0' }}>
            {/*<Breadcrumb style={{ margin: '16px 0' }}>*/}
            {/*  {extraBreadcrumbItems}*/}
            {/*</Breadcrumb>*/}
            <div style={{ padding: 24, background: '#fff', minHeight: 100 }}>
              <Route exact path="/" component={GettingStarted}></Route>
              <Route path="/GettingStarted" component={GettingStarted}></Route>

              {routeItem}
            </div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>IMI ©2019 Created by <b>FE</b> part</Footer>
        </Layout>
      </Layout>
    </>
  )
}

export default LayoutComponent
